module.exports = __webpack_public_path__ + "img/goal3.c6b4aad9.png";